import {
  getTransactionGroupRangeKey,
  TransactionGroupBy,
  transformMetricGroup,
  transformProjectGroup,
  transformServiceGroup
} from '@zerops/models/transaction-debit';
import { HashMap } from '@zerops/zef/core';
import { FEATURE_NAME } from './transaction-debit-base.constant';
import {
  TransactionDebitGroupRequestPayload,
  TransactionDebitGroupUpdateSuccessPayload
} from './transaction-debit-base.model';
import {
  createTimeSeriesSubscriptionName,
  timeSeriesGroupExists,
  transformTimeSeriesGroupData
} from '../shared';

export function getTransactionGroupRangeSubscriptionName(
  groupBy: string,
  timeGroupBy: string,
  projectId?: string,
  serviceId?: string,
  key?: string
) {
  return createTimeSeriesSubscriptionName(
    FEATURE_NAME,
    groupBy,
    timeGroupBy,
    key,
    projectId,
    serviceId,
    undefined // no metricId for transaction-debit
  );
}

export function transactionGroupExists(
  payload: TransactionDebitGroupRequestPayload,
  transactionStateData: HashMap<any>
) {
  return timeSeriesGroupExists(
    payload,
    transactionStateData,
    getTransactionGroupRangeKey,
    (p) => p.groupBy,
    (p) => p.groupRange,
    (p) => p.projectId,
    (p) => p.serviceId
  );
}

export function transformDebitGroupTransformByMetric(
  data: TransactionDebitGroupUpdateSuccessPayload,
  state: HashMap<any>
) {
  // Use shared transform logic with custom transforms for transaction-debit specific logic
  return transformTimeSeriesGroupData(
    data,
    state,
    getTransactionGroupRangeKey,
    {
      [TransactionGroupBy.Metric]: (items, rangeKey) => transformMetricGroup(items, rangeKey),
      [TransactionGroupBy.Service]: (items, rangeKey) => transformServiceGroup(items, rangeKey),
      [TransactionGroupBy.Project]: (items, rangeKey) => {
        const transformed = transformProjectGroup(items);
        return {
          [rangeKey]: {
            data: transformed?.data?.length ? transformed.data : []
          }
        };
      }
    }
  );
}

export function buildTransactionDebitGroupSearchRequest(
  payload: TransactionDebitGroupRequestPayload,
  clientId: string,
  receiverId?: string
) {
  const search: any[] = [
    { name: 'clientId', operator: 'eq', value: clientId }
  ];

  if (payload.projectId) {
    search.push({ name: 'projectId', operator: 'eq', value: payload.projectId });
  }

  if (payload.serviceId) {
    search.push({ name: 'stackId', operator: 'eq', value: payload.serviceId });
  }

  return {
    search: search.filter(Boolean),
    receiverId,
    subscriptionName: getTransactionGroupRangeSubscriptionName(
      payload.groupBy,
      payload.groupRange.timeGroupBy,
      payload.projectId,
      payload.serviceId,
      payload.groupRange.key
    ),
    groupBy: payload.groupBy,
    timeGroupBy: payload.groupRange.timeGroupBy,
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    limit: payload.groupRange.range?.from && payload.groupRange.range?.to && !payload.groupRange.limit ? undefined : payload.groupRange.limit,
    from: payload.groupRange.limit ? undefined : payload.groupRange.range?.from,
    till: payload.groupRange.limit ? undefined : payload.groupRange.range?.to
  };
}
